<div class="container-fluid py-3">

  <!-- Hero Banner: Score + Executive KPIs (current snapshot) -->
  <app-hero-banner
    [identityScore]="identityScore()"
    [executiveMetrics]="executiveMetrics()"
    [isLoading]="heroBannerLoading()"
    (tierChange)="onTierChange($event)"
    (openKpiDetail)="onOpenKpiDetail($event)"
  />

  <!-- Privileged Access Summary (current snapshot) -->
  <div class="row g-3 mt-2">
    <div class="col-12">
      <app-privileged-access
        [data]="privilegedAccess()"
        [isLoading]="privilegedLoading()"
        (openDetail)="onOpenPrivilegedDetail()"
      />
    </div>
  </div>

  <!-- Posture Breakdown + Misconfigured Identities -->
  <div class="row g-3 mt-2 align-items-stretch">
    <div class="col-lg-6 col-md-12 d-flex">
      <app-posture-breakdown
        class="w-100"
        [identityScore]="identityScore()"
        [isLoading]="scoreLoading()"
      />
    </div>
    <div class="col-lg-6 col-md-12 d-flex">
      <app-xdr-correlation
        class="w-100"
        [identityRisks]="identityRisks()"
        [isLoading]="risksLoading()"
        [unavailable]="risksUnavailable()"
      />
    </div>
  </div>

  <!-- Detection Trend (30-day lookback) -->
  <div class="row g-3 mt-2">
    <div class="col-12">
      <app-detection-trend
        [trendData]="detectionTrend()"
        [isLoading]="trendLoading()"
        (openDetail)="onOpenDetectionTrendDetail()"
      />
    </div>
  </div>

  <!-- Shared View Details dialog (one instance, opened by all widgets above) -->
  <app-identity-entity-dialog
    [config]="entityDialogConfig()"
    [visible]="showEntityDialog()"
    (close)="onEntityDialogClose()"
  />

</div>
